module.exports = __webpack_public_path__ + "static/media/IMG-20220519-WA0014.e87bdce8.jpg";